import { InputLabel, TextField, Typography } from '@mui/material'
import { Autocomplete } from '@mui/lab'
import React, { FC } from 'react'
import { getOptionLabel, ILabelProps, noOptionsText } from '../../utils'

interface IProps {
  className: string
  autoCompleteOpen: any
  hideLoader: boolean
  userNameChange: any
  onChangeSelection: any
  setAutoCompleteOpen: any
  filteredUserList: any[]
  searchText: string
  isLoading: boolean
  labelText: string
}
const CustomInputLabel: FC<ILabelProps> = ({ id, label }) => (
  <InputLabel {...(id && { htmlFor: id })}>
    <Typography variant="h6" component="span">
      {label}
    </Typography>
  </InputLabel>
)

const AutoCompleteContainer: FC<IProps> = ({
  className,
  autoCompleteOpen,
  hideLoader,
  userNameChange,
  onChangeSelection,
  setAutoCompleteOpen,
  filteredUserList,
  searchText,
  isLoading,
  labelText,
}) => {
  return (
    <>
      <CustomInputLabel label={labelText} />
      <Autocomplete
        id="agentAutocomplete"
        className={className}
        open={autoCompleteOpen}
        disabled={!hideLoader}
        onInputChange={userNameChange}
        onChange={onChangeSelection}
        onOpen={() => {
          setAutoCompleteOpen(true)
        }}
        onClose={() => {
          setAutoCompleteOpen(false)
        }}
        options={filteredUserList}
        getOptionLabel={getOptionLabel}
        noOptionsText={noOptionsText(searchText, isLoading)}
        renderInput={(params) => (
          <div>
            <TextField
              {...params}
              variant="outlined"
              InputProps={{
                ...params.InputProps,
              }}
            />
          </div>
        )}
      />
    </>
  )
}

export default AutoCompleteContainer
